import { gsap } from 'gsap';
import { component } from 'picoapp';

export default component((node, ctx) => {
  const SESSION_KEY = 'hide_announcement_bar';
  const contents = node.querySelectorAll('*');
  const close = node.querySelector('.js-close-announcement-bar');

  const showAnnouncementBar = () => {
    gsap.set(node, { display: 'block' });
    ctx.hydrate({ showAnnouncement: true });
    document.body.classList.add('show-announcement-bar');
  };

  const closeAnnouncementBar = () => {
    const tl = gsap.timeline({
      onComplete: () => {
        sessionStorage.setItem(SESSION_KEY, true);
        document.body.classList.remove('show-announcement-bar');
      },
    });
    tl
      .to(contents, { autoAlpha: 0, duration: 0.2 })
      .to(node, { height: 0, ease: 'power3.out' })
      .set(node, { display: 'none' });
  };

  if (!sessionStorage.getItem(SESSION_KEY)) {
    showAnnouncementBar();
  }

  close.addEventListener('click', closeAnnouncementBar);
});